import * as moment from "moment";
import { database, auth } from "../firebase";
import fetch from "node-fetch";
import { requestActiveCompanyDetails } from "../../redux/actions/single-list";

export const retrieveContactListDetails = async (info) => {
  try {
    const contactList = await database
      .collection("companies")
      .doc(info.companyId)
      .collection("contactLists")
      .doc(info.id)
      .get();

    if (contactList.exists) {
      const details = {
        name: contactList.data().name ? contactList.data().name : null,
        description: contactList.data().description
          ? contactList.data().description
          : null,
      };

      return { error: null, payload: details };
    } else {
      throw new Error("Kunne ikke hente kontaktlistedetaljer.");
    }
  } catch (e) {
    throw new Error(e);
  }
};

export const retrieveContactListRecords = async (info) => {
  try {
    const allRecords = [];
    const records = await database
      .collection("companies")
      .doc(info.companyId)
      .collection("contactLists")
      .doc(info.id)
      .collection("records")
      .orderBy("timestamp")
      .get();
    if (records.size > 0) {
      records.forEach((record) => {
        allRecords.push({
          id: record.id,
          addedBy: record.data().addedBy ? record.data().addedBy : null,
          logoUrl: record.data().logoUrl ? record.data().logoUrl : null,
          timestamp: record.data().timestamp ? record.data().timestamp : null,
          verified: record.data().verified ? record.data().verified : false,
          general: {
            firstName: record.data().general.firstName
              ? record.data().general.firstName
              : null,
            lastName: record.data().general.lastName
              ? record.data().general.lastName
              : null,
          },
          contact: {
            phone: record.data().contact.phone
              ? record.data().contact.phone
              : null,
            email: record.data().contact.email
              ? record.data().contact.email
              : null,
            website: record.data().contact.website
              ? record.data().contact.website
              : null,
          },
          company: {
            name: record.data().company.name
              ? record.data().company.name
              : null,
            position: record.data().company.position
              ? record.data().company.position
              : null,
          },
          social: {
            twitter: record.data().social.twitter
              ? record.data().social.twitter
              : null,
            facebook: record.data().social.facebook
              ? record.data().social.facebook
              : null,
          },
          address: {
            street: record.data().address.street
              ? record.data().address.street
              : null,
            postalCode: record.data().address.postalCode
              ? record.data().address.postalCode
              : null,
            city: record.data().address.city
              ? record.data().address.city
              : null,
            country: record.data().address.country
              ? record.data().address.country
              : null,
          },
        });
      });
    }
    return Promise.all(allRecords).then((result) => {
      return { payload: result, error: null };
    });
  } catch (e) {
    throw new Error(e);
  }
};

export const addSingleContactListRecord = async (info) => {
  try {
    const recordEdit = info.record;
    recordEdit.timestamp = moment().unix();
    await database
      .collection("companies")
      .doc(info.companyId)
      .collection("contactLists")
      .doc(info.id)
      .collection("records")
      .add(recordEdit);
    return { error: null };
  } catch (e) {
    throw new Error(e);
  }
};

export const updateSingleContactListRecord = async (info) => {
  try {
    await database
      .collection("companies")
      .doc(info.companyId)
      .collection("contactLists")
      .doc(info.listId)
      .collection("records")
      .doc(info.record.id)
      .update({
        address: info.record.address,
        company: info.record.company,
        contact: info.record.contact,
        general: info.record.general,
        social: info.record.social,
      });
    return { error: null, payload: info.record };
  } catch (e) {
    throw new Error(e);
  }
};

export const fetchSingleRecord = async (info) => {
  try {
    const record = await database
      .collection("companies")
      .doc(info.companyId)
      .collection("contactLists")
      .doc(info.listId)
      .collection("records")
      .doc(info.id)
      .get();
    const allInfo = {
      id: record.id,
      addedBy: record.data().addedBy ? record.data().addedBy : null,
      logoUrl: record.data().logoUrl ? record.data().logoUrl : null,
      timestamp: record.data().timestamp ? record.data().timestamp : null,
      general: {
        firstName: record.data().general.firstName
          ? record.data().general.firstName
          : null,
        lastName: record.data().general.lastName
          ? record.data().general.lastName
          : null,
      },
      contact: {
        phone: record.data().contact.phone ? record.data().contact.phone : null,
        email: record.data().contact.email ? record.data().contact.email : null,
        website: record.data().contact.website
          ? record.data().contact.website
          : null,
      },
      company: {
        name: record.data().company.name ? record.data().company.name : null,
        position: record.data().company.position
          ? record.data().company.position
          : null,
      },
      social: {
        twitter: record.data().social.twitter
          ? record.data().social.twitter
          : null,
        facebook: record.data().social.facebook
          ? record.data().social.facebook
          : null,
      },
      address: {
        street: record.data().address.street
          ? record.data().address.street
          : null,
        postalCode: record.data().address.postalCode
          ? record.data().address.postalCode
          : null,
        city: record.data().address.city ? record.data().address.city : null,
        country: record.data().address.country
          ? record.data().address.country
          : null,
      },
    };

    return { error: null, payload: allInfo };
  } catch (e) {
    throw new Error(e);
  }
};

export const deleteMultipleContactsArray = async (details) => {
  try {
    if (details && details.items.length > 0) {
      const deletions = [];
      details.items.forEach((key) => {
        const single = deleteContact({
          companyId: details.companyId,
          listId: details.listId,
          key: key,
        });
        deletions.push(single);
      });

      return Promise.all(deletions).then((result) => {
        return { error: null, payload: result };
      });
    } else {
      throw new Error("Kunne ikke slette kontakter.");
    }
  } catch (e) {
    throw new Error(e);
  }
};

export const deleteContact = async (details) => {
  try {
    await database
      .collection("companies")
      .doc(details.companyId)
      .collection("contactLists")
      .doc(details.listId)
      .collection("records")
      .doc(details.key)
      .delete();
    return { error: null, payload: details.key };
  } catch (e) {
    throw new Error(e);
  }
};

export const addCsvRecord = async (details) => {
  try {
    if (details.data.overrides && details.data.rows) {
      var contacts = [];
      details.data.rows.forEach((row) => {
        var contact = {
          addedBy: auth.currentUser.uid,
          logoUrl: null,
          general: {
            firstName: null,
            lastName: null,
          },
          contact: {
            phone: null,
            email: null,
            website: null,
          },
          company: {
            name: null,
            position: null,
          },
          social: {
            twitter: null,
            facebook: null,
          },
          address: {
            street: null,
            postalCode: null,
            city: null,
            country: null,
          },
        };
        Object.entries(row).map(([key, val]) => {
          var block = details.data.overrides.filter((x) =>
            x.key === key ? x : null
          );
          if (block[0].parent === "general" && block[0].value === "firstName") {
            contact.general.firstName = val;
          }
          if (block[0].parent === "general" && block[0].value === "lastName") {
            contact.general.lastName = val;
          }
          if (block[0].parent === "contact" && block[0].value === "phone") {
            contact.contact.phone = val;
          }
          if (block[0].parent === "contact" && block[0].value === "email") {
            contact.contact.email = val;
          }
          if (block[0].parent === "contact" && block[0].value === "website") {
            contact.contact.website = val;
          }
          if (block[0].parent === "company" && block[0].value === "name") {
            contact.company.name = val;
          }
          if (block[0].parent === "company" && block[0].value === "position") {
            contact.company.position = val;
          }
          if (block[0].parent === "address" && block[0].value === "street") {
            contact.address.street = val;
          }
          if (
            block[0].parent === "address" &&
            block[0].value === "postalCode"
          ) {
            contact.address.postalCode = val;
          }
          if (block[0].parent === "address" && block[0].value === "city") {
            contact.address.postalCode = val;
          }
          if (
            block[0].parent === "address" &&
            block[0].value === "postalCode"
          ) {
            contact.address.postalCode = val;
          }
          if (block[0].parent === "address" && block[0].value === "country") {
            contact.address.postalCode = val;
          }
        });
        contacts.push(contact);
      });
      await uploadCsvRecords({
        companyId: details.companyId,
        listId: details.listId,
        list: contacts,
      });
      return { error: null };
    }
  } catch (e) {
    throw new Error(e);
  }
};

export const uploadCsvRecords = async (details) => {
  try {
    if (details.list && details.list.length > 0) {
      const additions = [];
      details.list.forEach((contact) => {
        if (contact && contact.general.firstName && contact.general.lastName) {
          const single = uploadSingleRecord({
            companyId: details.companyId,
            listId: details.listId,
            record: contact,
          });
          additions.push(single);
        }
      });
      return Promise.all(additions).then((result) => {
        return { error: null };
      });
    } else {
      throw new Error("Kunne ikke slette kontakter.");
    }
  } catch (e) {
    throw new Error(e);
  }
};

export const uploadSingleRecord = async (details) => {
  try {
    const recordEdit = details.record;
    recordEdit.timestamp = moment().unix();
    await database
      .collection("companies")
      .doc(details.companyId)
      .collection("contactLists")
      .doc(details.listId)
      .collection("records")
      .add(recordEdit);
    return { error: null };
  } catch (e) {
    throw new Error(e);
  }
};
